/*
  PDP compare/size modals — extracted from sections/gg-product-pdp.liquid so it ships deferred
  from a cacheable asset. Behaviour is unchanged: the listeners are attached once after parse.
*/
var modalLinks = document.querySelectorAll('.modalLink');
  for (let i = 0; i < modalLinks.length; i++) {
    modalLinks[i].addEventListener("click", function() {
      if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
        document.getElementById(modalLinks[i].dataset.modal).classList.add('cc-popup--visible');
        document.body.classList.add('cc-modal-visible');
      }
    });
  }

  var closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');
  for (let i = 0; i < closeModalLinks.length; i++) {
    closeModalLinks[i].addEventListener("click", function() {
      if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
        document.getElementById(closeModalLinks[i].dataset.modalclose).classList.remove('cc-popup--visible');
        document.body.classList.remove('cc-modal-visible');
      }
    });
  }

  var closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');
  for (let i = 0; i < closeModalLinksViaBG.length; i++) {
    closeModalLinksViaBG[i].addEventListener("click", function() {
      if (typeof document.getElementById(closeModalLinksViaBG[i].dataset.modalclose != 'undefined')) {
        document.getElementById(closeModalLinksViaBG[i].dataset.modalclose).classList.remove('cc-popup--visible');
        document.body.classList.remove('cc-modal-visible');
      }
    });
  }
